import apiClient from '../client';

export default async function getSepaOrderState(
  orderId: string,
  customerIp?: string | null,
) {
  return apiClient.processingSepaGetOrder({
    order_id: orderId,
    customer_ip: customerIp,
  });
}
